/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Careers_Post_ApplyInputs */

const ja_careers_post_apply = /** @type {(inputs: Careers_Post_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このポジションに応募する`)
};

const en_careers_post_apply = /** @type {(inputs: Careers_Post_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`APPLY FOR THIS POSITION`)
};

/**
* | output |
* | --- |
* | "APPLY FOR THIS POSITION" |
*
* @param {Careers_Post_ApplyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const careers_post_apply = /** @type {((inputs?: Careers_Post_ApplyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careers_Post_ApplyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_careers_post_apply(inputs)
	return en_careers_post_apply(inputs)
});